// Übersetzt Texte im "Joy Wishlist"-App-Widget (Shadow DOM, App-Einstellungen bieten
// keine Sprachoption). Beobachtet die Shadow-Roots per MutationObserver, da die
// Komponente (Lit) bei Statuswechseln (z.B. Hinzufügen/Entfernen) neu rendert.
(function () {
  var TRANSLATIONS = {
    'Add to Wishlist': 'Zur Wunschliste hinzufügen'
  };

  function translateNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      var text = node.nodeValue.trim();
      if (TRANSLATIONS[text]) node.nodeValue = node.nodeValue.replace(text, TRANSLATIONS[text]);
      return;
    }
    if (node.nodeType === Node.ELEMENT_NODE) {
      var ariaLabel = node.getAttribute && node.getAttribute('aria-label');
      if (ariaLabel && TRANSLATIONS[ariaLabel]) node.setAttribute('aria-label', TRANSLATIONS[ariaLabel]);
    }
    // ELEMENT_NODE und DOCUMENT_FRAGMENT_NODE (der Shadow-Root selbst) haben beide
    // childNodes -> in beiden Fällen weiter rekursieren.
    if (node.childNodes) node.childNodes.forEach(translateNode);
  }

  function watchShadowRoot(root) {
    translateNode(root);
    var observer = new MutationObserver(function () {
      translateNode(root);
    });
    observer.observe(root, { childList: true, subtree: true, characterData: true });
  }

  // Die App definiert ihr Custom Element erst nach dem Laden ihres eigenen (später
  // eingebundenen) Scripts, und erzeugt den Shadow-Root im connectedCallback. Ein
  // einmaliges "el.shadowRoot vorhanden?"-Polling ist daher zu zeitkritisch -> statt
  // dessen wird attachShadow global abgefangen, das trifft jeden Fall zuverlässig.
  var origAttachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init) {
    var root = origAttachShadow.call(this, init);
    if (this.tagName === 'JOY-WISHLIST-BUTTON') watchShadowRoot(root);
    return root;
  };

  document.querySelectorAll('joy-wishlist-button').forEach(function (el) {
    if (el.shadowRoot) watchShadowRoot(el.shadowRoot);
  });
})();
